import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";
import { useIntl } from "react-intl";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const FormWrapper = (props) => {
  const {
    mode,
    onFinish,
    onFinishFailed,
    onValuesChange,
    setInitialForm,
    onDecline,
    saveLoading,
    createText,
    current,
    onContinue,
    onBack,
    steps,
    nextDisabled,
    direction,
    children,
    layout,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();

  useEffect(() => {
    setInitialForm(form);
  }, []);

  return (
    <Form
      scrollToFirstError
      {...layout}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      form={form}
      onValuesChange={onValuesChange}
    >
      {children}
      <div className="actions">
        {current > 0 ? (
          <Button
            style={{ minWidth: "135px" }}
            onClick={onBack}
            icon={
              direction === "rtl" ? (
                <ArrowRightOutlined />
              ) : (
                <ArrowLeftOutlined />
              )
            }
          >
            {intl.formatMessage({
              id: "app.actions.back",
            })}
          </Button>
        ) : null}
        {current !== steps.length - 1 ? (
          <Button
            type="primary"
            onClick={onContinue}
            disabled={nextDisabled}
            style={{ minWidth: "135px" }}
          >
            {intl.formatMessage({
              id: "app.actions.next",
            })}
          </Button>
        ) : null}
        {current === steps.length - 1 ? (
          <Button
            type="primary"
            htmlType="submit"
            loading={saveLoading}
            disabled={nextDisabled}
            style={{ minWidth: "135px" }}
          >
            {createText}
          </Button>
        ) : null}
      </div>
    </Form>
  );
};

FormWrapper.propTypes = {
  mode: PropTypes.string,
  onFinish: PropTypes.func,
  onFinishFailed: PropTypes.func,
  onDecline: PropTypes.func,
  addImage: PropTypes.func,
  saveLoading: PropTypes.bool,
};

export default FormWrapper;
